import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props.theme.spacing.xxl};
  min-height: ${props => props.fullHeight ? '50vh' : 'auto'};
`;

const Spinner = styled.div`
  width: ${props => props.size || '32px'};
  height: ${props => props.size || '32px'};
  border: 3px solid ${props => props.theme.colors.border.light};
  border-top: 3px solid ${props => props.theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.p`
  margin-left: ${props => props.theme.spacing.md};
  color: ${props => props.theme.colors.text.secondary};
  font-size: ${props => props.theme.fontSize.sm};
`;

const LoadingSpinner = ({ 
  size, 
  text = 'Loading...', 
  showText = true, 
  fullHeight = false 
}) => {
  return (
    <SpinnerWrapper fullHeight={fullHeight}>
      <Spinner size={size} />
      {showText && <LoadingText>{text}</LoadingText>}
    </SpinnerWrapper>
  );
};

export default LoadingSpinner;